import React from "react";
import DragDropImageAndText from "./components";
const DragDropShowAnswer = ({ data }) => {
  return <DragDropImageAndText data={data} />;
};
export default DragDropShowAnswer;
